(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingGenderController', SeekingGenderController);

    SeekingGenderController.$inject = ['$scope', '$state', 'SeekingGender', 'SeekingGenderSearch'];

    function SeekingGenderController ($scope, $state, SeekingGender, SeekingGenderSearch) {
        var vm = this;
        
        vm.seekingGenders = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            SeekingGender.query(function(result) {
                vm.seekingGenders = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SeekingGenderSearch.query({query: vm.searchQuery}, function(result) {
                vm.seekingGenders = result;
            });
        }    }
})();
